import React from 'react'
import { Typography, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import Alert from 'redesign/components/atoms/alert'
import { getEventDateText } from 'redesign/components/organisms/event-card/utils'
import { formatDate } from 'redesign/shared/date'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { CONTENT_TYPES } from 'types/cms'
import { Container } from './styles'
import type { CmsContentTitleProps } from './types'

const CmsContentTitle: React.FC<CmsContentTitleProps> = ({
  title,
  restrictAbsenceComment,
  isAbsenceRestricted = false,
  content,
}) => {
  const { t, locale } = useFavurTranslation()
  const { palette } = useTheme()
  const { sentAt, contentType, startDate, endDate } = content
  const showRestrictedAbsences = Boolean(isAbsenceRestricted && restrictAbsenceComment)
  const showSentDate = contentType === CONTENT_TYPES.newsletter && sentAt
  const showEventDates = contentType === CONTENT_TYPES.event

  return (
    <Container>
      <Typography variant="h1">{title}</Typography>
      {showSentDate && (
        <Typography variant="body1" color={palette.text.secondary}>
          {t('page.cms.content.sentAt', {
            date: formatDate({ date: sentAt, dateFormat: DATE_FORMAT_VARIANTS.longWithoutWeekday, locale, t }),
          })}
        </Typography>
      )}
      {showEventDates && (
        <Typography variant="body1" color={palette.text.secondary}>
          {getEventDateText({
            event: content,
            startDate,
            endDate,
            locale,
            t,
          })}
        </Typography>
      )}
      {showRestrictedAbsences && (
        <Alert title={t('page.cms.content.absenceBlocker.title')} severity="info" body={restrictAbsenceComment} />
      )}
    </Container>
  )
}

export default CmsContentTitle
